module.exports = __webpack_public_path__ + "static/media/loading-icon.e45bf660.svg";